/**
 * Created by Benoit Valkenberg on 03-12-17.
 */
import {SuiSidebar} from "ng2-semantic-ui/dist";
import {ViewChild} from "@angular/core";


export abstract class GenericAppComponent{

    @ViewChild(SuiSidebar)
    sidebar: SuiSidebar;

    public sidebarButtonClicked(){
        this.sidebar.toggle();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/generic-app.ts